import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Navbar from "./components/Navbar";
import Homep from './pages/Homep';
import Servicesp from './pages/Servicesp';
import Aboutusp from './pages/Aboutusp';
import Quotep from './pages/Quotep';
import Footer from './components/Footer';
import ProductsP from './pages/ProductsP';
import Contactp from './pages/Contactp';
import Profilesp from './pages/Profilesp';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Router>
      <div className="App">
        <NavbarWithLocation isScrolled={isScrolled} />
        <div className='content'>
          <Routes>
            <Route index path='/' element={<Homep />} />
            <Route path='/Products' element={<ProductsP />} />
            <Route path='Servicesp' element={<Servicesp />} />
            <Route path='/Aboutusp' element={<Aboutusp />} />
            <Route path='/Quotep' element={<Quotep />}></Route>
            <Route path='/contact' element={<Contactp />} />
            <Route path='/profiles' element={<Profilesp />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

const NavbarWithLocation = ({ isScrolled }) => {
  const location = useLocation();
  return <Navbar location={location} isScrolled={isScrolled} />;
};

export default App;